<template>
  <el-card>
    <el-row :gutter="20">
      <el-col span="2">
        <el-button type="danger" size="default" @click="addHandle()">我要请假</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="dataList"
      border="border"
      height="73vh"
      style="width: 100%;"
    >
      <el-table-column width="40px" prop="reason" header-align="center" align="center" type="expand">
        <template v-slot="scope">
          请假原因：{{ scope.row.reason }}
        </template>
      </el-table-column>
      <el-table-column type="index" header-align="center" align="center" width="100" label="序号">
        <template v-slot="scope">
          <span>{{ (page - 1) * size + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="姓名"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="deptName"
        header-align="center"
        align="center"
        label="部门"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="start"
        header-align="center"
        align="center"
        label="起始"
        min-width="180"
      >
        <template v-slot="scope">
          {{ $filters.dateFilterMi(scope.row.start)  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="end"
        header-align="center"
        align="center"
        label="截止"
        min-width="180"
      >
        <template v-slot="scope">
          {{ $filters.dateFilterMi(scope.row.end)  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="days"
        header-align="center"
        align="center"
        label="请假天数(天)"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="type"
        header-align="center"
        align="center"
        label="请假类型"
        min-width="150"
      >
        <template v-slot="scope">
          <span v-if="scope.row.type === 1" style="color: orange;">病假</span>
          <span v-if="scope.row.type === 2" style="color: #f56c6c;">事假</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="请假状态" min-width="120">
        <template v-slot="scope">
          <span v-if="scope.row.status === 1" style="color: orange;">请假中</span>
          <span v-if="scope.row.status === 3" style="color: #17B3A3;">已同意</span>
          <span v-if="scope.row.status === 2" style="color: #f56c6c;">不同意</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" width="120" label="请假单" min-width="120">
        <template v-slot="scope">
          <el-button
            type="text"
            size="default"
            v-if="scope.row.status === 3"
            @click="pdfHandle(scope.row.id)"
          >
            请假单
          </el-button>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" width="150" label="操作" min-width="120">
        <template v-slot="scope">
          <el-button
            type="text"
            :disabled="scope.row.status === 3 || scope.row.mine != true"
            @click="deleteHandle(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-card>
  <leave-add v-model="addVisiable" ref="add" @refreshDataList="loadDataList"></leave-add>
</template>
<script setup>
import { ref } from 'vue'
import LeaveAdd from './components/leave-add.vue'
import { searchLeaveByPage } from '@/api/leave'
import { useRoute } from 'vue-router'

const total = ref(0)
const page = ref(1)
const size = ref(10)
const addVisiable = ref(false)

const dataList = ref([])
const route = useRoute()
const add = ref()
const addHandle = () => {
  addVisiable.value = true
}

const loadDataList = async () => {
  const result = await searchLeaveByPage({
    page: page.value,
    size: size.value,
    pageUrl: route.matched[0].name
  })

  total.value = result.total
  dataList.value = result.list
}

loadDataList()

const handleSizeChange = currentSize => {
  size.value = currentSize
}

const handleCurrentChange = currentPage => {
  page.value = currentPage
}
</script>
